import { createAction } from '@'
import FetchMappingCoverage from './FetchMappingCoverage'
import { $regionCoverage, $regionCoverageLoading, $regionCoverageQuery } from '../stores'

const GetRegionCoverage = createAction('GetRegionCoverage', async params => {
    const last = $regionCoverageQuery.getState()
    const query = {
        region_id: `${params.region_id}`.trim(),
        supplier_code: params.supplier_code || undefined,
        page: params.page,
        page_size: params.page_size
    }
    const isLatest = () => $regionCoverageQuery.getState() === query

    $regionCoverageQuery.setState(() => query)
    // Paging and refetches keep the current result on screen; only a different region/source starts blank.
    if (!last || last.region_id !== query.region_id || last.supplier_code !== query.supplier_code) {
        $regionCoverage.setState(() => null)
    }
    $regionCoverageLoading.setState(() => true)
    try {
        const data = await FetchMappingCoverage({ method: 'GET', path: '/region', params: query }, { silent: true })
        if (!isLatest()) {
            return
        }
        const lastPage = Math.ceil((data.hotels_total || 0) / (data.page_size || 1))
        if (data.hotels && !data.hotels.length && lastPage && data.page > lastPage) {
            // Removing the last rows of the last page leaves it empty.
            await GetRegionCoverage({ ...query, page: lastPage })
            return
        }
        $regionCoverage.setState(() => data)
    } catch (e) {
        // 404 / 400 bodies carry a readable message — show it instead of an empty page.
        if (isLatest()) {
            $regionCoverage.setState(() => e.data || { success: false, message: e.message })
        }
    } finally {
        if (isLatest()) {
            $regionCoverageLoading.setState(() => false)
        }
    }
})

export default GetRegionCoverage
